var map = {
	"./bootstrap_cronos.svg": 68,
	"./bootstrap_dark.svg": 69,
	"./bootstrap_light.svg": 70,
	"./bootstrap_material.svg": 71,
	"./bootstrap_metis.svg": 72,
	"./bootstrap_sirius.svg": 73,
	"./bootstrap_zeus.svg": 74,
	"./bulma_cronos.svg": 75,
	"./bulma_metis.svg": 76,
	"./bulma_plain.svg": 77,
	"./bulma_zeus.svg": 78,
	"./material-ui_materialui.svg": 79,
	"./material-ui_nereus.svg": 80,
	"./tailwind_artemis.svg": 81,
	"./tailwind_atis.svg": 82,
	"./tailwind_bendis.svg": 83,
	"./tailwind_metis.svg": 84,
	"./tailwind_plain.svg": 85,
	"./tailwind_shuffle.svg": 86,
	"./tailwind_yofte.svg": 87,
	"./tailwind_zeus.svg": 88,
	"./tailwind_zospace.svg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;